'use client';

import React, { useState, useEffect, useRef } from 'react';

const LazyYoutube = ({
  videoId,
  styles,
  autoPlay,
}: {
  videoId: string;
  styles?: string;
  autoPlay?: boolean;
}) => {
  const [load, setLoad] = useState(false);
  const videoRef = useRef(null);

  useEffect(() => {
    const currentRef = videoRef.current;

    const observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        setLoad(true);
        observer.disconnect();
      }
    });

    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, []);
  const src = autoPlay
    ? `https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1&mute=1`
    : `https://www.youtube-nocookie.com/embed/${videoId}`;
  return (
    <div ref={videoRef} className={`relative flex-grow ${styles}`}>
      {load ? (
        <iframe
          width="100%"
          height="100%"
          className="animate-fadeIn rounded-md"
          src={src}
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
        ></iframe>
      ) : (
        <div>Loading...</div>
      )}
    </div>
  );
};

export default LazyYoutube;
